import { API } from "../../../api/api";
import { MailingAPIRoutes } from "./apiRoutes";

const getHistoryUsersById = ({ ids }: { ids: number[] }) => {
    return API.request({
        routeID: MailingAPIRoutes.GET_HISTORY_USERS,
        odataParameters: {
            skip: 0,
            top: 1000000,
            ...(ids.length && { filter: "id in " + ids }),
            orderby: "-id"
        }
    });
};

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: MailingAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const getMailingLists =  ({ page, top, search, subsidiaries, status }) => {
    let odataParameters = {
        skip: page * top,
        top,
        orderby: "id"
    };

    if (search) {
        odataParameters["search"] = search;
    }
    if (status) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}active eq ${status}`;
    }
    if (subsidiaries && subsidiaries.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}subsidiary_id in (${subsidiaries
            .map(c => c)
            .join(",")},)`;
    }
    return API.request({
        routeID: MailingAPIRoutes.GET_MAILING_LISTS,
        odataParameters
    });
};

const getMailingList = mailingListId => {
    let odataParameters = {}
    if (mailingListId) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}id eq ${mailingListId}`;
    }
    return API.request({
        routeID: MailingAPIRoutes.GET_MAILING_LIST,
        odataParameters
    });
};

const getMailingListTypes = () => {
    return API.request({
        routeID: MailingAPIRoutes.GET_MAILING_LISTS_TYPES
    });
};

const addMailingLists = data => {
    return API.request({
        routeID: MailingAPIRoutes.ADD_MAILING_LISTS,
        parameters: {
            name: data.mailingList.name,
            subsidiary: data.mailingList.subsidiary,
            lists: data.mailingList.lists,
            active: true
        },
        formData: false
    });
};

const editMailingList = data => {
    return API.request({
        routeID: MailingAPIRoutes.EDIT_MAILING_LIST,
        parameters: {
            id: data.id,
            name: data.mailingList.name,
            subsidiary: data.mailingList.subsidiary,
            lists: data.mailingList.lists,
            active: data.mailingList.active
        },
        formData: false
    });
};

const activateMailingList = data => {
    return API.request({
        routeID: MailingAPIRoutes.EDIT_MAILING_LIST,
        parameters: {
            id: data.mailingList.id,
            name: data.mailingList.name,
            subsidiary: data.mailingList.subsidiary,
            lists: data.mailingList.lists,
            active: true
        },
        formData: false
    });
}

const deactivateMailingList = data => {
    return API.request({
        routeID: MailingAPIRoutes.EDIT_MAILING_LIST,
        parameters: {
            id: data.mailingList.id,
            name: data.mailingList.name,
            subsidiary: data.mailingList.subsidiary,
            lists: data.mailingList.lists,
            active: false
        },
        formData: false
    });
}

export const mailingAPI = {
    getHistoryUsersById,
    getSubsidiaries,
    getMailingLists,
    getMailingList,
    getMailingListTypes,
    addMailingLists,
    editMailingList,
    activateMailingList,
    deactivateMailingList
};
